import { Reducer } from '@reduxjs/toolkit';

const appRestRoleReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { restRole: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, restRole: payload };
};

export default appRestRoleReducer;
